import {
  Box,
  Card,
  CardBody,
  Flex,
  Icon,
  Text,
} from "@chakra-ui/react";
import { Link, } from "react-router-dom";
import { ChevronRightIcon, } from "@heroicons/react/24/outline";
import { RoutesMap, } from "../../../../routes.tsx";

/**
 * Card that shows empty upcoming payments state
 */
export function UpcomingPaymentCardEmpty() {
  return (
    <Card
      width="100%"
      borderRadius="xl"
      variant="elevated"
      position="relative"
    >
      <CardBody px={5} py={5}>
        <Flex height="100%" flexDir="column" justifyContent="space-between">
          <Box mb={5}>
            <Text fontSize="xl" fontWeight="bold">
              Платежей в этом месяце нет
            </Text>
            <Text fontSize="xs" color="gray.500" mt={1}>
              Следующий платеж появится в следующем месяце
            </Text>
          </Box>

          <Link to={RoutesMap.payments.index}>
            <Flex alignItems="center" justifyContent="space-between">
              <Text fontSize="md" fontWeight="medium">
                Посмотреть все платежи
              </Text>

              <Icon
                as={ChevronRightIcon}
                boxSize={4}
                color="gray.600"
              />
            </Flex>
          </Link>
        </Flex>
      </CardBody>
    </Card>
  );
}
